import { Console } from '@utils/logger';

interface GeolocationResponse {
  country_code: string;
  country_name: string;
  region: string;
  city: string;
  timezone: string;
}

let countryCache: string | null = null;

/**
 * Detects if the user is accessing from Chile based on their IP address
 * @returns Promise<boolean> - true if user is from Chile, false otherwise
 */
export async function isUserFromChile(): Promise<boolean> {
  if (countryCache) {
    return countryCache === 'CL';
  }

  try {
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      Console.warn('IP geolocation API failed, defaulting to allow tracking');
      return true;
    }

    const data = (await response.json()) as GeolocationResponse;

    countryCache = data.country_code;

    Console.log('User location detected:', {
      country: data.country_name,
      countryCode: data.country_code,
      region: data.region,
      city: data.city,
    });

    return data.country_code === 'CL';
  } catch (error) {
    Console.warn('Failed to detect user location:', error);
    return true;
  }
}

/**
 * Synchronous version that returns cached result or null
 * @returns boolean | null - cached result or null if not available
 */
export function isUserFromChileSync(): boolean | null {
  if (countryCache) {
    return countryCache === 'CL';
  }
  return null;
}
